import React from 'react';

import { Chip } from 'uikit/chips';
import { Typo } from 'uikit/content';

import styles from '../styles/initiativeChips.module.scss';

const InitiativeChips = ({ chips, emptyText, onChipClick }) => (
  <ul className={styles.element}>
    {!chips.length ? (
      <li>
        <Typo className={styles.empty} element="span" variant="b01">{emptyText}</Typo>
      </li>
    ) : (
      chips.map((chip) => (
        <li className={styles.chipContainer} key={chip.id}>
          <Chip
            className={styles.chip}
            onClick={() => onChipClick(chip)}
            text={chip.name}
          />
        </li>
      ))
    )}
  </ul>
);

export default React.memo(InitiativeChips);
